import get from 'lodash/get';
import uniqBy from 'lodash/uniqBy';

const infusionCheckMixins= {
  computed: {
    errors() {
      if (!this.emitter.$store) {
        return [];
      }
      const errors = get(
        this.emitter.$store.getters['validation/errorsByFieldAndId'],
        `caseLogicDescription.${this.control.parent.id}`,
        [],
      ).filter(
        error => error.metadata && error.metadata.checkKey === this.ikey
      );
      return uniqBy(errors, 'message');
    },
    medFluidError() {
      return this.errors.find(error => error.metadata.errorId === 'medFluid');
    },
    ivDisabledError() {
      return this.errors.find(error => error.metadata.errorId === 'ivDisabled');
    },
    bagVolumeError() {
      return this.errors.find(error => error.metadata.errorId === 'bagVolume');
    },
    ivCategoryError() {
      return this.errors.find(error => error.metadata.errorId === 'ivCategory');
    },
    ivPortError() {
      return this.errors.find(error => error.metadata.errorId === 'ivPort');
    },
    ivSiteError() {
      return this.errors.find(error => error.metadata.errorId === 'ivSite');
    },
    ivSideError() {
      return this.errors.find(error => error.metadata.errorId === 'ivSide');
    },
    locationMedError() {
      return this.errors.find(error => error.metadata.errorId === 'locationMed');
    },
    locationFluidError() {
      return this.errors.find(error => error.metadata.errorId === 'locationFluid');
    },
    dripSetError() {
      return this.errors.find(error => error.metadata.errorId === 'dripSet');
    },
    secondaryDisabledError() {
      return this.errors.find(error => error.metadata.errorId === 'secondaryDisabled');
    },
    formularyDisabledError() {
      return this.errors.find(error => error.metadata.errorId === 'formularyDisabled');
    },
    dosingTypeDisabledError() {
      return this.errors.find(error => error.metadata.errorId === 'dosingTypeDisabled');
    },
    unitDisabledError() {
      return this.errors.find(error => error.metadata.errorId === 'unitDisabled');
    },
    adjustmentDisabledError() {
      return this.errors.find(error => error.metadata.errorId === 'adjustmentDisabled');
    },
    matchingActionError() {
      return this.errors.find(error => error.metadata.errorId === 'matchingAction');
    },
    methodDisabledError() {
      return this.errors.find(error => error.metadata.errorId === 'methodDisabled');
    },
  }
};

export default infusionCheckMixins;